export default __webpack_public_path__ + "static/media/750x600_wakeup05.01a41fae.jpg";